import { forwardRef, type HTMLProps } from "react";
import PasswordInput from "../../../Common/Forms/PasswordInput";

interface Props extends Omit<HTMLProps<HTMLInputElement>, "type" | "ref"> {
    maskUsername: boolean;
}

const LoginUsername = forwardRef<HTMLInputElement, Props>(({ maskUsername, ...props }, forwardRef) => {
    if(maskUsername) {
        return (
            <PasswordInput
                ref={forwardRef}
                {...props}
            />
        );
    }

    return (
        <input
            ref={forwardRef}
            type="text"
            {...props}
        />
    );
});

LoginUsername.displayName = "LoginUsername";

export default LoginUsername;
